import { useState } from 'react'
import { Card } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PendingArtworksList } from '../components/PendingArtworksList'
import { PublishedArtworksList } from '../components/PublishedArtworksList'
import { CopyrightReviewList } from '../components/CopyrightReviewList'
import { CopyrightDashboard } from '../components/CopyrightDashboard'
import { PendingDashboard } from '../components/PendingDashboard'
import { PublishedDashboard } from '../components/PublishedDashboard'

export function ExportArtworksPage() {
  const [activeTab, setActiveTab] = useState<'pending' | 'published' | 'copyright'>('pending')

  return (
    <div className="space-y-8 p-8">
      <div className="space-y-1">
        <h1 className="font-serif text-4xl font-semibold tracking-tight">Artwork Approvals</h1>
        <p className="text-muted-foreground text-base">Review and manage artwork approvals</p>
      </div>

      <Card>
        <Tabs
          value={activeTab}
          onValueChange={(v) => setActiveTab(v as 'pending' | 'published' | 'copyright')}
        >
          <TabsList className="w-full justify-start rounded-none border-b border-border/50 bg-transparent p-0">
            <TabsTrigger
              value="pending"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary px-6"
            >
              Pending
            </TabsTrigger>
            <TabsTrigger
              value="published"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary px-6"
            >
              Published
            </TabsTrigger>
            <TabsTrigger
              value="copyright"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary px-6"
            >
              Copyright Review
            </TabsTrigger>
          </TabsList>

          <TabsContent value="pending" className="space-y-8 p-6">
            <PendingDashboard />
            <PendingArtworksList />
          </TabsContent>

          <TabsContent value="published" className="space-y-8 p-6">
            <PublishedDashboard />
            <PublishedArtworksList />
          </TabsContent>

          <TabsContent value="copyright" className="space-y-8 p-6">
            <CopyrightDashboard />
            <CopyrightReviewList />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  )
}

